import { SERVER_API } from "../../../config.json";
import Cookies from 'universal-cookie';
const cookies = new Cookies();
//Layout
// eslint-disable-next-line require-yield

let tokenUser = cookies.get('usercode');
function tokenAPI()
 {           
	 if(tokenUser && tokenUser.token)
	 {
		 return tokenUser.token;
	 }
	 else{
         window.location.reload();
	 }
 }

function* GetDataLayoutFromApi() {
	var test = tokenAPI();
	const response = yield fetch(SERVER_API + "api/Menu/GetMenu", {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
		}
	});
	
	const Data = yield response.json();
	if (Data.status === "OK") {
		return yield Data.data;
	}
	return yield {};
}
//Noti
function* GetDataNotification(DataNoti) {	
	
	try{
		var test = tokenAPI();
		const response = yield fetch(SERVER_API + "api/Notification/GetNoti", {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + test
			},
			body: JSON.stringify({
				"KeyName": DataNoti.KeyName
			})
		});
		const Data = yield response.json();
		if (Data.status === "OK" && Data.amount > 0) {
			const DataNotiparam = {
				//"userEmail": DataNoti.User,
				//"UserCode": DataNoti.UserCode,
				"Type": 1
			};
			const response2 = yield fetch(SERVER_API + Data.data[0].url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + test
				},
				body: JSON.stringify(DataNotiparam)
			});
			const Data1 = yield response2.json();
			if (Data1.status === "OK") {
				return yield Data1.data;
			}
		}
		return yield {};
	}
	catch(e)
	{
		console.log("error GetDataNotification ",e);
	}
	
}
//SetNoti
function* SetDataNotification(DataLayout) {
	var test = tokenAPI();
	const DataNotiparam = {
		"PlanID": DataLayout,
		//"UserCode":  cookies.get('usercode').userCode ? cookies.get('usercode').userCode : "",
		"Type": 2
	};
	const response2 = yield fetch(SERVER_API + "api/Notification/GetListDetailNotification", {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
		},
		body: JSON.stringify(DataNotiparam)
	});
	const Data = yield response2.json();
	if (Data.status === "OK") {
		return yield Data;
	}
	return yield {};
}
//Update Noti
function * UpdateDataNotificationApi(){
	var test = tokenAPI();
	const response = yield fetch(SERVER_API + "api/Notification/UpdateViewAll", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        }
    });
    const Data = yield response.json();
    if (Data) {        
	   console.log("Thành công");
    }
    else{
		console.log("Thất bại");
    }
    return yield {};
}
//LogOut
function* LogOut() {			
	try{		
		var test = tokenAPI();
		const response = yield fetch(SERVER_API + "api/User/LogOut", {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + test
			},
		});
		if(response.status === 200)
		{
			return yield true;
		}
		else
		{
			return yield false;
		}
	}
	catch(e)
	{
		console.log("error LogOut ",e);
	}
	
}
//CreateFuntionHygen
export const Api = {
	GetDataLayoutFromApi,
	GetDataNotification,
	SetDataNotification,
	LogOut, 
	UpdateDataNotificationApi
	//ExportFuntionHygen
}